module.exports = __webpack_public_path__ + "media/images/emoticons/house-d8a4b64f097cb4322109017395678f7f.gif";